import React, { Component } from 'react';
import qs from 'qs';
import Titulo from '../comum/Titulo';
import buscarVeiculo from '../../actions/veiculo/buscarVeiculo';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import Autorizacao from '../../security/Autorizacao';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import { PERFIL_ADMIN, getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, getGestorOperacoes } from '../../security/securityContext';
import 'moment/locale/pt-br'
import moment from 'moment';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ptBR from 'date-fns/locale/pt-BR';
import InputMask from 'react-input-mask';
import { renderField } from '../../util/arraysUtil';
import { maxTamanhoCampoTipoOcorrencia, maxValueMonetario, renderFieldMonetarioLabelEncima, renderTextArea, required } from '../../util/inputs';
import cadastrarManutencaoVeiculo from '../../actions/manutencao-veiculo/cadastrar-manutencao-veiculo';
import buscarRegistrosManutencaoVeiculo from '../../actions/manutencao-veiculo/buscar-registros-manutencao-veiculo';
import { showSuccessMsg } from '../../util/messagesUtil';
import ManutencaoVeiculo from './ManutencaoVeiculo';
import Moment from 'react-moment';
import selecionaManutencaoVeiculo from '../../actions/manutencao-veiculo/seleciona-manutencao-veiculo';
import atualizarManutencaoVeiculo from '../../actions/manutencao-veiculo/atualizar-manutencao-veiculo';
import excluirManutencaoVeiculo from '../../actions/manutencao-veiculo/excluir-manutencao-veiculo';
import PainelFiltragem from './PainelFiltrosManutencaoVeiculo';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { alterouFiltro } from '../../util/filtros';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export const validate = (values) => {
    const errors = {};
    
    if (!values.tipoOcorrencia) {
        errors.tipoOcorrencia = 'Campo obrigatório'
    }
    
    return errors
};

const ModalConfirmacaoExclusaoManutencaoVeiculo = ({ excluir, selecionaManutencaoVeiculo, manutencaoVeiculo }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoManutencaoVeiculo" tabIndex="-1" role="dialog"
      aria-labelledby="modalConfirmacao" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body texto-centralizado">
            <p>Deseja excluir o Manutenção veículo <strong>{manutencaoVeiculo ? manutencaoVeiculo.tipoOcorrencia : ''}
            </strong> selecionado ?</p>
          </div>
          <div className="modal-footer ">
            <button id='cancelar' type="button" className="btn btn-outline-secondary"
              data-dismiss="modal"
                onClick={() => selecionaManutencaoVeiculo()}>Cancelar
            </button>
            <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
              onClick={() => excluir()}>Excluir
            </button>
          </div>
        </div>
      </div>
    </div>);
    
export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col-lg-1 col-xl-1"></div>
            <div className="col">Data ocorrência</div>
            <div className="col">Registrado Por</div>
            <div className="col">Data entrada</div>
            <div className="col">Tipo ocorrência</div>
            <div className="col">Valor Total Gasto</div>
            <div className="col-sm-2 d-flex justify-content-center">Ações</div>
        </div>
    </div>
);


export class PainelRegistrarManutencaoVeiculo extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);

        this.state = {
            dataOcorrencia: null,
            veiculo: null
        }
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        if (parametros) {
            const veiculo = parametros.veiculo;            
            this.props.buscarVeiculo(veiculo, this.props.empresaSelecionada.id);
            this.buscarRegistrosManutencaoVeiculo(veiculo);
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
            if (parametros) {
                this.buscarRegistrosManutencaoVeiculo(parametros.veiculo);
            }
        }
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], { type: 'text/csv;charset=utf-8' }));
        a.download = `Dados - Manutencoes do Veiculo ${this.props.veiculo.id} - ${this.props.veiculo.descricao}.csv`;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    exportarTabelaReservasRepasse() {
        let arquivo = 'Descricao Veículo;Data Entrada;Registrado Por;Data Ocorrência;Tipo Ocorrência;Valor Total Gasto;Ocorrência\n';

        arquivo = `${arquivo}${this.props.manutencoesVeiculo.map(it => {
            const descricaoVeiculo = this.props.veiculo.descricao;
            const dataEntrada = moment(it.dataCadastro).format('DD/MM/YYYY');
            const dataOcorrencia = moment(it.dataOcorrencia).format('DD/MM/YYYY');
            const ocorrencia = `"${it.ocorrencia}"`;
            const valorTotalGasto = it.valorTotalGasto ? it.valorTotalGasto : '';


            return `${descricaoVeiculo};${dataEntrada};${it.registradoPor};${dataOcorrencia};${it.tipoOcorrencia};"${valorTotalGasto}";${ocorrencia}`;
        }).join('\n')}\n`;

        this.executarDownload(arquivo);
    }

    buscarRegistrosManutencaoVeiculo(veiculo) {
        this.props.buscarRegistrosManutencaoVeiculo(veiculo, this.props.empresaSelecionada.id, 1, 100, this.props.filtrosAdicionados);
    }

    selecionarDataOcorrencia(date) {
        if (date) {
            this.setState({ dataOcorrencia: date });
        } else {
            this.setState({ dataOcorrencia: null });
        }
    }

    getDescricaoVeiculo() {
        let descricao = `Descrição/Placa: ${this.props.veiculo.descricao}`;

        if (this.props.veiculo.placa) {
            descricao = `${descricao}/${this.props.veiculo.placa}`;
        }

        if (this.props.veiculo.modelo) {
            descricao = `${descricao}, Modelo: ${this.props.veiculo.modelo}`;
        }

        if (this.props.veiculo.tipoVeiculo && this.props.veiculo.tipoVeiculo.valor) {
            descricao = `${descricao}, Tipo: ${this.props.veiculo.tipoVeiculo.valor}`;
        }

        if (this.props.veiculo.renavam) {
            descricao = `${descricao}, Renavam: ${this.props.veiculo.renavam}`;
        }

        if (this.props.veiculo.chassi) {
            descricao = `${descricao}, Chassi: ${this.props.veiculo.chassi}`;
        }

        if (this.props.veiculo.anoFabricacao) {
            descricao = `${descricao}, Ano de Fabricação: ${this.props.veiculo.anoFabricacao}`;
        }

        if (this.props.veiculo.quilometragem) {
            descricao = `${descricao}, Quilometragem: ${this.props.veiculo.quilometragem}`;
        }

        if (this.props.veiculo.numeroEixo) {
            descricao = `${descricao}, N° Eixos: ${this.props.veiculo.numeroEixo}`;
        }

        if (this.props.veiculo.dataVencimentoCsv) {
            descricao = `${descricao}, Data Vencimento CSV: ${this.props.veiculo.dataVencimentoCsv}`;
        }

        return descricao;
    }

    excluir() {        
        this.props.excluirManutencaoVeiculo(this.props.manutencaoVeiculoSelecionado.id, this.props.veiculo.id, this.props.empresaSelecionada.id)
            .then(() => {                
                this.props.selecionaManutencaoVeiculo();
                showSuccessMsg('O registro manutenção de veículo foi excluído com sucesso'); 
            });
    }

    exibirManutencaoVeiculo() {
        if (this.props.manutencoesVeiculo.length == 0) {
            return <div>Nenhum registro manutenção de veículo.</div>
        }

        return this.props.manutencoesVeiculo.map(it =>
            <ManutencaoVeiculo  key={`manutencao-veiculo-${it.id}`} manutencaoVeiculo={it}
            selecionarDataOcorrencia={this.selecionarDataOcorrencia.bind(this)}
            limparSelecaoManutencaoVeiculo={this.limparCampos.bind(this)} /> );
    }

    exibirTabelaManutencoesVeiculo() {
        return (<div className="col-12 conteudo-internas">
            {this.props.manutencoesVeiculo.length != 0 && <CabecalhoTabela />}
            <div className="lista-table">
                {this.exibirManutencaoVeiculo()}
            </div>
        </div>
        )
    }

    limparSelecao(e){
        e.preventDefault();
        this.limparCampos();
    }

    limparCampos() {
        this.selecionarDataOcorrencia(null);
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'tipoOcorrencia', '');
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'ocorrencia', '');
        this.props.changeFieldValue('formularioPainelRegistroManutencaoVeiculo', 'valorTotalGasto', '');
        this.props.selecionaManutencaoVeiculo();
    }

    montarParametros(values) {        
        return {
            id: this.props.manutencaoVeiculoSelecionado.id,
            empresaId: this.props.empresaSelecionada.id,
            veiculoId: this.props.veiculo.id,
            dataOcorrencia: this.state.dataOcorrencia,
            tipoOcorrencia: values.tipoOcorrencia,
            ocorrencia: values.ocorrencia,
            valorTotalGasto: this.props.valorTotalGasto ? this.props.valorTotalGasto.replace('R$', '') : null
        }
    }

    submit(values) {
        const parametros = this.montarParametros(values);
        
        if (this.props.manutencaoVeiculoSelecionado.id) {
            this.props.atualizarManutencaoVeiculo(parametros)
                .then(() => {
                    showSuccessMsg('O registro manutenção de veículo foi alterado com sucesso');
                    this.limparCampos();
                });
        } else {
            this.props.cadastrarManutencaoVeiculo(parametros)
                .then(() => {
                    showSuccessMsg('Registro manutenção de veículo salvo com sucesso'); 
                    this.limparCampos();
                });
        }
    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                <div className="row internas">
                    <Titulo texto="Painel Registrar Manutenção Veículo" urlRetorno="/painel-veiculos" />

                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                <li className="nav-item dropdown nome-empresa">
                                    <div className='col-md-6'>
                                        <CampoSelecionarEmpresa />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Autorizacao>                    
                    <div className="col-12 filtro-busca">
                        <PainelFiltragem/>
                    </div>
                    <div className="col-12 filtro-busca mb-3">
                        <div className="dropdown">
                            <button className="btn btn-laranja dropdown-toggle float-right" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Exportar
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item btn btn-laranja" onClick={() => this.exportarTabelaReservasRepasse()}>Exportar Lista</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <h4>{this.getDescricaoVeiculo()}</h4>
                    <h4 id="titulo-page" className="text-center"><p className="linha"></p></h4>
                    <form onSubmit={handleSubmit(this.submit)}>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Registro manutenção</legend>

                            <div className='form-row col-12 col-sm-9 col-md-9 mt-2'>
                                <label>Data da entrada: &nbsp; </label> {this.props.manutencaoVeiculoSelecionado.dataCadastro ? <Moment format="DD/MM/YYYY">{this.props.manutencaoVeiculoSelecionado.dataCadastro}</Moment>: '-'}
                            </div>
                            <div className='form-row col-12 col-sm-9 col-md-9 mt-2'>
                                <label>Registrado Por: &nbsp;</label> {this.props.manutencaoVeiculoSelecionado.registradoPor ? this.props.manutencaoVeiculoSelecionado.registradoPor : '-'}
                            </div>
                            <div className='form-row col-12 col-sm-9 col-md-9 mt-2'>
                                <div className='col-12 col-sm-4 col-md-4'>
                                    <label className='mt-2'>Data Ocorrência:</label>
                                    <DatePicker
                                        className='form-control col-md-12'
                                        value={this.state.dataOcorrencia}
                                        locale="pt-BR"                                        
                                        selected={this.state.dataOcorrencia && moment(this.state.dataOcorrencia)
                                            .toDate()}
                                        onChange={date => this.selecionarDataOcorrencia(date)}
                                        dateFormat="dd/MM/yyyy"
                                        customInput={<InputMask mask="99/99/9999" />}
                                    />
                                </div>                                
                            </div>                            
                            <div className='form-row col-12 mt-2'>
                                <div className='col-12 col-md-6 col-sm-6'>
                                    <Field name='tipoOcorrencia' type="text" component={renderField} minLength='2' label='Tipo ocorrência'
                                                validate={[required, maxTamanhoCampoTipoOcorrencia]}
                                                css="form-control" readOnly={false} />
                                </div>
                            </div>
                            <div className='form-row col-12 mt-2'>
                                <div className='col-12 col-sm-3 col-md-2 mr-2'>
                                    <Field name="valorTotalGasto" validate={[maxValueMonetario]}
                                                component={renderFieldMonetarioLabelEncima}
                                                label='Valor Total Gasto'/>
                                </div>
                            </div>
                            <div className="form-row col-12 mt-2">
                                <div className='col-12 cold-md-12 col-sm-12 campo-ocorrencia'>
                                    <Field name='ocorrencia' css="form-control cold-12 col-md-12" component={renderTextArea}
                                        className="form-control" max={2000} label="Ocorrência:" validate={[required]}/>
                                </div>
                            </div>
                        </fieldset>

                        <div className="modal-footer">
                            <button className='btn btn-primary' onClick={(e) => this.limparSelecao(e)}>
                               Limpar
                            </button>
                            <button type="submit"
                                disabled={invalid || submitting || !this.state.dataOcorrencia}
                                className="btn btn-laranja">Salvar
                            </button>
                        </div>
                    </form>
                    
                </div>
                <div className='mb-2'>
                    {this.exibirTabelaManutencoesVeiculo()}
                </div>
                <ModalConfirmacaoExclusaoManutencaoVeiculo 
                    excluir={this.excluir.bind(this)} 
                    selecionaManutencaoVeiculo={this.props.selecionaManutencaoVeiculo.bind(this)} 
                    manutencaoVeiculo={this.props.manutencaoVeiculoSelecionado} />
            </Autorizacao>

        )
    }
}


export const mapStateToProps = state => {    
    return {
        empresaSelecionada: state.empresaSelecionada,
        veiculo: state.veiculo,
        manutencoesVeiculo: state.manutencoesVeiculo.manutencoesVeiculo,
        manutencaoVeiculoSelecionado: state.manutencoesVeiculo.manutencaoVeiculoSelecionado,
        filtrosAdicionados: state.filtrosAdicionadosManutencaoVeiculo,
        valorTotalGasto: formValueSelector('formularioPainelRegistroManutencaoVeiculo')(state, 'valorTotalGasto')
    }
};

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        buscarVeiculo,
        cadastrarManutencaoVeiculo,
        atualizarManutencaoVeiculo,
        buscarRegistrosManutencaoVeiculo,
        selecionaManutencaoVeiculo,
        excluirManutencaoVeiculo 
    }, dispatch)
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelRegistroManutencaoVeiculo',
    validate
})(PainelRegistrarManutencaoVeiculo)))